(ns frontend.view.kpi-reporting.kpi-categories.settings
  (:require
   [common.localization :as loc]
   [common.util :as cu :refer [flip]]
   [common.entity :as entity]
   [clojure.string :as string]
   [potpuri.core :as p :refer [fn-> fn->> index-by]]
   [frontend.actions.kpi-category :as kpi-category-actions]
   [frontend.view.modals.components.input :as input]
   [frontend.view.kpi-reporting.kpi-categories.settings-events :as events]
   [frontend.view.kpi-reporting.kpi-categories.events :as category-events]
   [frontend.view.kpi-reporting.kpi-categories.db :as db]
   [frontend.view.components.kpi :as kpi-components]
   [frontend.bootstrap.components :as rbs]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.dynamic.view :as dynamic]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

(defn save-category-attribute!
  [{:keys [category entity-atom attribute new-value]}]
  (let [old-value (get @entity-atom attribute)]
    (when-not (= new-value old-value)
      (swap! entity-atom assoc attribute new-value)
      (events/save-category!
       category
       attribute
       new-value
       (fn [_])
       (fn [_]
         (when (= new-value (get @entity-atom attribute))
           (swap! entity-atom assoc attribute old-value)))))))

(defn email-greeting-select
  [{:keys [category entity-atom]}]
  (let [attribute :kpi-category/email-greeting-contact
        value (or (get @entity-atom attribute) :first-name)
        options [{:value :first-name :label "Reporting contact's first name"}
                 {:value :full-name  :label "Reporting contact's full name"}
                 {:value :last-name  :label "Reporting contact's last name"}
                 {:value :blank      :label "Leave blank"}]]
    [:div
     {:class "mt-2"}
     [data-input/view
      {:editor-type   :editor.type/select
       :data-type     :data.type/keyword
       :is-clearable? false
       :full-width?   true
       :placeholder   (loc/tr :select-placeholder)
       :value         value
       :options       options
       :on-change     (fn [new-value & _]
                        (save-category-attribute! {:category    category
                                                   :entity-atom entity-atom
                                                   :attribute   attribute
                                                   :new-value   new-value}))}]]))

(defn email-ending-select
  [{:keys [category entity-atom]}]
  (let [attribute :kpi-category/email-ending-contact
        value (or (get @entity-atom attribute) :first-name)
        options [{:value :first-name :label "Our contact's first name"}
                 {:value :full-name  :label "Our contact's full name"}
                 {:value :blank      :label "Leave blank"}]]
    [:div
     {:class "mt-2"}
     [data-input/view
      {:editor-type   :editor.type/select
       :data-type     :data.type/keyword
       :is-clearable? false
       :full-width?   true
       :placeholder   (loc/tr :select-placeholder)
       :value         value
       :options       options
       :on-change     (fn [new-value & _]
                        (save-category-attribute! {:category    category
                                                   :entity-atom entity-atom
                                                   :attribute   attribute
                                                   :new-value   new-value}))}]]))

(defn their-contact-str
  [kw contact]
  (let [{:keys [account/first-name account/last-name]} contact
        kw (or kw :first-name)]
    (case kw
      :first-name (str " " first-name)
      :last-name (str " " last-name)
      :full-name (str " " first-name " " last-name)
      "")))

(defn our-contact-str
  [kw contact]
  (let [{:keys [account/first-name account/last-name]} contact
        kw (or kw :first-name)]
    (case kw
      :first-name (str "\n" first-name)
      :last-name (str "\n" last-name)
      :full-name (str "\n" first-name " " last-name)
      "")))

(defn email-template
  [{:keys [category edit-category entity-atom state-atom edit-state]}]
  (let [email-title (:kpi-category/email-title category)
        email-greeting (:kpi-category/email-greeting category)
        email-greeting-contact (:kpi-category/email-greeting-contact category)
        their-contact {:account/first-name "John"
                       :account/last-name  "Smith"}
        email-greeting-contact-str (their-contact-str email-greeting-contact their-contact)
        full-greeting (str email-greeting email-greeting-contact-str)
        email-copy (:kpi-category/email-copy category)
        email-ending (:kpi-category/email-ending category)
        email-ending-contact (:kpi-category/email-ending-contact category)
        our-contact {:account/first-name "James"
                     :account/last-name  "Bond"}
        email-ending-contact-str (our-contact-str email-ending-contact our-contact)
        full-ending (str email-ending email-ending-contact-str)
        ending-note-1 (loc/tr :email-template-ending-note-1 ["James Bond" "Demo Ventures"])
        ending-note-2 (loc/tr :email-template-ending-note-2 ["Demo Ventures"])
        reporting-email "reporting@zapflow.com"
        full-email (str ""
                        (when-not (empty? full-greeting)
                          (str full-greeting ",\n\n"))
                        email-copy
                        "\n\n"
                        full-ending)]

    [:div.kpi-email-template

     [:div.d-flex.justify-content-end.align-items-center
      [:div.kpi-email-template-title.d-none.d-lg-flex
       [:div.kpi-email-template-title-preview (loc/tr :kpi-config/message-preview)
        [:div.kpi-email-template-title-preview-text (loc/tr :kpi-config/edit-in-the-left-column)]]]]

     [:div.kpi-email-template-wrapper
      [:div.kpi-email-template-left
       [:div.kpi-email-template-fields
        [:div.kpi-email-template-line.kpi-email-subject
         [input/simple-text-field
          {:type        :text
           :entity      edit-category
           :attribute   :kpi-category/email-title
           :label       (loc/tr :subject)
           :entity-atom entity-atom
           :validate!   (fn [attribute val]
                          (swap! edit-state assoc attribute val)
                          (when (empty? val)
                            (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
           :on-save!    (fn [attribute new-value on-success! on-error!]
                          ;;make sure local state is cleared when no changes:
                          (when (and (= new-value email-title)
                                     (fn? on-success!))
                            (on-success!))
                          (when-not (= new-value email-title)
                            ;;optimistic save to frontend db:
                            (swap! entity-atom assoc attribute new-value)
                            (events/save-category!
                             category
                             attribute
                             new-value
                             (fn [res]
                               (when on-success!
                                 (on-success!)))
                             (fn [err]
                               ;;retract the optimistic save above
                               (when (= new-value (get @entity-atom attribute))
                                 (swap! entity-atom assoc attribute email-title))
                               (on-error! err)))))}]]

        [:div.kpi-email-template-line.kpi-email-greeting
         [input/simple-text-field
          {:type        :text
           :entity      edit-category
           :attribute   :kpi-category/email-greeting
           :label       (loc/tr :greeting)
           :entity-atom entity-atom
           :validate!   (fn [attribute val]
                          (swap! edit-state assoc attribute val)
                          (when (empty? val)
                            (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
           :on-save!    (fn [attribute new-value on-success! on-error!]
                          ;;make sure local state is cleared when no changes:
                          (when (and (= new-value email-greeting)
                                     (fn? on-success!))
                            (on-success!))
                          (when-not (= new-value email-greeting)
                            ;;optimistic save to frontend db:
                            (swap! entity-atom assoc attribute new-value)
                            (events/save-category!
                             category
                             attribute
                             new-value
                             (fn [res]
                               (when on-success!
                                 (on-success!)))
                             (fn [err]
                               ;;retract the optimistic save above
                               (when (= new-value (get @entity-atom attribute))
                                 (swap! entity-atom assoc attribute email-greeting))
                               (on-error! err)))))}]
         [email-greeting-select
          {:category    category
           :entity-atom entity-atom
           :state-atom  state-atom
           :edit-state  edit-state}]]

        [:div.kpi-email-template-line.kpi-email-instructions
         [input/simple-text-field
          {:type        :textarea
           :entity      edit-category
           :attribute   :kpi-category/email-copy
           :label       (loc/tr :instructions)
           :entity-atom entity-atom
           :validate!   (fn [attribute val]
                          (swap! edit-state assoc attribute val)
                          (when (empty? val)
                            (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
           :on-save!    (fn [attribute new-value on-success! on-error!]
                          ;;make sure local state is cleared when no changes:
                          (when (and (= new-value email-copy)
                                     (fn? on-success!))
                            (on-success!))
                          (when-not (= new-value email-copy)
                            ;;optimistic save to frontend db:
                            (swap! entity-atom assoc attribute new-value)
                            (events/save-category!
                             category
                             attribute
                             new-value
                             (fn [res]
                               (when on-success!
                                 (on-success!)))
                             (fn [err]
                               ;;retract the optimistic save above
                               (when (= new-value (get @entity-atom attribute))
                                 (swap! entity-atom assoc attribute email-copy))
                               (on-error! err)))))}]]]

       [:div.kpi-email-template-line.kpi-email-ending
        [input/simple-text-field
         {:type        :text
          :entity      edit-category
          :attribute   :kpi-category/email-ending
          :label       (loc/tr :ending)
          :entity-atom entity-atom
          :validate!   (fn [attribute val]
                         (swap! edit-state assoc attribute val)
                         (when (empty? val)
                           (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
          :on-save!    (fn [attribute new-value on-success! on-error!]
                         ;;make sure local state is cleared when no changes:
                         (when (and (= new-value email-ending)
                                    (fn? on-success!))
                           (on-success!))
                         (when-not (= new-value email-ending)
                           ;;optimistic save to frontend db:
                           (swap! entity-atom assoc attribute new-value)
                           (events/save-category!
                            category
                            attribute
                            new-value
                            (fn [res]
                              (when on-success!
                                (on-success!)))
                            (fn [err]
                              ;;retract the optimistic save above
                              (when (= new-value (get @entity-atom attribute))
                                (swap! entity-atom assoc attribute email-ending))
                              (on-error! err)))))}]
        [email-ending-select
         {:category    category
          :entity-atom entity-atom
          :state-atom  state-atom
          :edit-state  edit-state}]]]

      [:div.kpi-email-template-title.d-lg-none
       [:div.kpi-email-template-title-preview (loc/tr :kpi-config/message-preview)
        [:div.kpi-email-template-title-preview-text (loc/tr :kpi-config/edit-in-the-left-column)]]]

      [:div.kpi-email-template-preview-wrapper

       [:div.kpi-email-template-preview
        [:div.kpi-email-template-top
         [:span.label (loc/tr :email/from) ":"] " " [:span.email-text "reporting@zapflow.com"]]
        [:div.kpi-email-template-top
         [:span.label (loc/tr :email/to) ":"] " " [:span.email-text "john.smith@targetcompany.com"]]
        [:div.kpi-email-template-top.mt-3
         [:span.label (loc/tr :sub) ":"] " " [:span.email-text email-title]]

        [:div.kpi-email-full-preview.preview.preview-textarea
         full-email
         "\n\n"
         [:span.kpi-email-preview-ending-note
          ending-note-1
          [:a.kpi-email-address
           {:href (str "mailto:" reporting-email)}
           reporting-email]
          ending-note-2]]]]]]))

(defn their-contact-cell
  [{:keys [member account company]} _modal-atom close-modal!]
  (let [company-id (:db/id company)
        guest-roles (->> @session/all-roles
                         (cu/only-entity :role/role :role/guest-sell-side)
                         (remove :common/disabled?)
                         (cu/only-entity :role/target company-id))
        guest-accounts (->> guest-roles
                            (map :role/subject)
                            (keep (fn->> (get @session/entities)))
                            (remove :common/disabled?))
        value (:db/id account)
        options (->> guest-accounts
                     (mapv (fn [c]
                             {:value (:db/id c)
                              :label (entity/display-string c :long)})))]
    [:div
     [:div.their-contact-infobox
      [:div.their-contact-infobox-icon [:i.fal.fa-exclamation-circle]]
      [:div.their-contact-infobox-text (loc/tr :category-settings/their-contact-info)]]
     [data-input/view
      {:editor-type   :editor.type/select
       :data-type     :data.type/ref-single
       :is-clearable? false
       :full-width?   true
       :placeholder   (loc/tr :select-placeholder)
       :value         value
       :options       options
       :on-change     (fn [new-value & _]
                        (kpi-category-actions/*->update-member!
                         {:member-id     (:db/id member)
                          :their-contact new-value}
                         (fn [_] (close-modal!))
                         (fn [e] (logging/error "kpi-member-update:" e))))}]]))

(defn our-contact-cell
  [{:keys [member owner]} _modal-atom close-modal!]
  (let [accounts (->> (session/active-accounts nil)
                      (sort-by (fn-> entity/display-string str string/lower-case)))
        value (:db/id owner)
        options (->> accounts
                     (mapv (fn [c]
                             {:value (:db/id c)
                              :label (entity/display-string c)})))]
    [data-input/view
     {:editor-type   :editor.type/select
      :data-type     :data.type/ref-single
      :is-clearable? false
      :full-width?   true
      :placeholder   (loc/tr :select-placeholder)
      :value         value
      :options       options
      :on-change     (fn [new-value & _]
                       (kpi-category-actions/*->update-member!
                        {:member-id   (:db/id member)
                         :our-contact new-value}
                        (fn [_] (close-modal!))
                        (fn [e] (logging/error "kpi-member-update:" e))))}]))

(defn status-cell
  [{:keys [member]} _modal-state close-modal!]
  (let [value (or (:kpi-member/status member) :kpi-member.status/active)
        options (->> [:kpi-member.status/active :kpi-member.status/paused]
                     (mapv (fn [s]
                             {:value s
                              :label (loc/tr s)})))]
    [data-input/view
     {:editor-type   :editor.type/select
      :data-type     :data.type/keyword
      :is-clearable? false
      :full-width?   true
      :placeholder   (loc/tr :select-placeholder)
      :value         value
      :options       options
      :on-change     (fn [new-value & _]
                       (kpi-category-actions/*->update-member!
                        {:member-id (:db/id member)
                         :status    new-value}
                        (fn [_] (close-modal!))
                        (fn [e] (logging/error "kpi-member-update:" e))))}]))

(defn members-view
  [{:keys [members state-atom]}]
  [:div.members-list.px-2.px-md-3

   [rbs/Table
    {:striped    false
     :bordered   false
     :hover      true
     :class-name "zapflow-table table-no-wrap-condenced"}
    [:thead
     [:tr
      [:th (loc/tr :kpi-member/status)]
      [:th (loc/tr :kpi-company)]
      [:th
       [:div
        {:class "flex items-center gap-2 *:p-0"}
        (loc/tr :their-contact)
        [button/secondary-open
         {:tooltip (loc/tr :category-settings/their-contact-info)}
         [:i.fal.fa-info-circle]]]]
      [:th (loc/tr :our-contact)]
      #_[:th (loc/tr :template)]
      [:th ""] ;;remove company from this category -column
      ]]
    [:tbody
     (doall
      (for [member members
            :let [member-id (:db/id member)
                  company (->> member
                               :kpi-member/asset
                               (get @session/entities))
                  owner (->> member
                             :common/owner
                             (get @session/entities))
                  contact (->> member
                               :kpi-member/account
                               (get @session/entities))]]
        ^{:key (:db/id member)}
        [:tr.kpi-member-row
         [:td.editable
          {:on-click (fn [_]
                       (modals/open-modal! dynamic/modal-key
                                           {:title     (loc/tr :kpi-member/status)
                                            :render-fn (partial status-cell
                                                                {:member     member
                                                                 :state-atom state-atom})}))}
          (or (:kpi-member/status member)
              :kpi-member.status/active)]
         [:td (entity/display-string company)]
         [:td.editable
          {:on-click (fn [_]
                       (modals/open-modal! dynamic/modal-key
                                           {:title     (loc/tr :their-contact)
                                            :render-fn (partial their-contact-cell
                                                                {:account    contact
                                                                 :member     member
                                                                 :state-atom state-atom
                                                                 :company    company})}))}
          (entity/display-string contact :long)]
         [:td.editable
          {:on-click (fn [_]
                       (modals/open-modal! dynamic/modal-key
                                           {:title     (loc/tr :our-contact)
                                            :render-fn (partial our-contact-cell
                                                                {:owner      owner
                                                                 :member     member
                                                                 :state-atom state-atom
                                                                 :company    company})}))}
          (entity/display-string owner)]
         #_[:td "template-selection"]
         [:td.text-center {:class-name (fu/cs "kpi-remove")}
          [:span.report-indicator.clickable
           {:on-click (partial category-events/start-remove-member! member-id)}
           [:i.fal.fa-trash-alt]]]]))]]])

(defn category-name-field
  [_state-atom entity-atom kpi-entity save-category!]
  [input/simple-text-field
   {:type      :text
    :entity    @entity-atom
    :attribute :kpi-category/name
    :label     (loc/tr :kpi-category/name)
    :validate! (fn [attribute value]
                 (when (string/blank? value)
                   (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
    :on-save!  (fn [attribute new-value on-success! on-error!]
                 (let [old-value (get @entity-atom attribute)]
                   (when (= new-value old-value) (on-success!))
                   (when-not (= new-value old-value)
                     (swap! entity-atom assoc attribute new-value)
                     (save-category! kpi-entity
                                     attribute
                                     new-value
                                     on-success!
                                     (fn [err]
                                       (when (= new-value (get @entity-atom attribute))
                                         (swap! entity-atom assoc attribute old-value))
                                       (on-error! err))))))}])

(defn view
  [category]
  (let [state db/settings-state
        category-id (:db/id category)
        edit-state (r/cursor state [:edit])
        entity-atom (r/cursor session/entities [category-id])
        state-atom (r/cursor state [:state-atom])]
    (fn [category]
      (let [{:keys [alert]} @state
            now (js/Date.)
            current-year (.getFullYear now)
            year-options (->> (range (- current-year 7) (+ current-year 2))
                              reverse)
            edit-category (merge category @edit-state)

            category-id (:db/id category)
            category-name (:kpi-category/name category)
            email-title (:kpi-category/email-title category)
            email-copy (:kpi-category/email-copy category)
            entities @session/entities
            members (->>
                     entities
                     vals
                     (cu/only-entity :kpi-member/target category-id)
                     (remove :common/disabled?)
                     (sort-by
                      (fn->> :kpi-member/asset (get entities) :asset/name str string/lower-case)))
            selected-tab-key (or (:active-key @db/settings-state) "companies")]
        [:div.kpi-category-settings.entity__container.pb-4
         [rbs/Tabs
          {:id         "kpi-settings-tabs"
           :class-name "kpi-settings-content px-3"
           :active-key selected-tab-key
           :on-select  (fn [k]
                         (swap! db/settings-state assoc :active-key k))}

          [rbs/Tab
           {:event-key "companies"
            :title     (loc/tr :companies)
            :disabled  false}
           (when (= selected-tab-key "companies")
             [:div
              [:div.kpi-settings-category-name
               [category-name-field state-atom entity-atom category events/save-category!]]
              [members-view
               {:members    members
                :state-atom state-atom}]
              (when (session/is-admin?)
                [:div.px-2.md:px-3.mt-3
                 [button/danger-solid
                  {:on-click   (fn [_]
                                 (category-events/start-remove-category! category))}
                  [:i.fal.fa-plus] [:span (loc/tr :kpi-category/delete-category)]]])])]

          [rbs/Tab
           {:event-key "report-template"
            :title     (loc/tr :report-template)
            :disabled  false}
           (when (= selected-tab-key "report-template")
             [kpi-components/kpi-view
              {:kpi-entity         category
               :state              state
               :open-kpi-curtain!  events/open-kpi-curtain!
               :save-kpi-entity!   events/save-category!
               :save-guidance!     (partial events/save-guidance! state)
               :update-guidance!   (partial events/update-guidance! state)
               :end-guidance-edit! (partial events/end-guidance-edit! state)
               :toggle-kpi!        events/toggle-kpi!
               :reorder!           (partial events/reorder! state)
               :remove-group-heading! (partial events/remove-group-heading! state)
               :add-group-heading! (partial events/add-group-heading! state)}])]

          [rbs/Tab
           {:event-key "email-template"
            :title     (loc/tr :email-template)
            :disabled  false}
           (when (= selected-tab-key "email-template")
             [email-template
              {:category      category
               :edit-category edit-category
               :entity-atom   entity-atom
               :state-atom    state-atom
               :edit-state    edit-state}])]]]))))
